import { StateWishlist, StateWishlistItem } from '@spa/lib/store/wishlists/WishlistsState';
import { DeleteProductFromMyWishlistInput } from '@spa/generated/graphql/graphql';

export interface FindDeleteFromWistParamsResult {
  readonly input: DeleteProductFromMyWishlistInput;
  readonly isDefault: boolean;
}

const findDeleteFromWishlistParams = (
  wishlists: ReadonlyArray<StateWishlist>,
  productCode: string
): FindDeleteFromWistParamsResult | undefined => {
  let wishlistId: string | undefined;
  let itemId: string | undefined;
  let isDefaultParam: boolean | undefined;

  for (const { id, items, isDefault } of wishlists) {
    const item: StateWishlistItem | undefined = items.find(
      (item: StateWishlistItem): boolean => item.sku === productCode
    );
    if (item) {
      wishlistId = id;
      itemId = item.id;
      isDefaultParam = isDefault;
      break;
    }
  }

  return wishlistId !== undefined && itemId !== undefined && isDefaultParam !== undefined
    ? {
        input: {
          id: wishlistId,
          itemId
        },
        isDefault: isDefaultParam
      }
    : undefined;
};

export default findDeleteFromWishlistParams;
